import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceObjectiveActionsProps<T> = {
  filters?: {
    page?: number
    search?: string
  }
  mapper?: (data: any) => T
}

export const useMaintenanceObjectiveActions = <T,>({
  filters: { search, page } = {},
  mapper = Mapper.default<T>(),
}: UseMaintenanceObjectiveActionsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceObjectiveActions', search, page],
    queryFn: () => {
      return privateAxios.get(`/maintenance/objective_actions`, {
        params: {
          search: search || undefined,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
